<!-- Mobile: compact chip row of dropdown toggles (re-uses openDropdown state).
     Only rendered on rental home + search-results routes via HeaderService. -->
<div class="mobile-nav-row d-flex d-lg-none" *ngIf="showMobileDropdowns && !commerceNavigation">
  <button
    type="button"
    class="mobile-chip"
    [class.mobile-chip--open]="openDropdown === 0"
    (click)="toggleDropdown($event, 0)"
    aria-label="Equipment Rentals"
  >
    <span>Equipment Rentals</span>
    <span class="caret icon-carrot fs-10"></span>
  </button>
  <button
    type="button"
    class="mobile-chip"
    [class.mobile-chip--open]="openDropdown === 1"
    (click)="toggleDropdown($event, 1)"
    aria-label="Buy it Now"
  >
    <span>Buy it Now</span>
    <span class="caret icon-carrot fs-10"></span>
  </button>
  <button
    type="button"
    class="mobile-chip"
    [class.mobile-chip--open]="openDropdown === 2"
    (click)="toggleDropdown($event, 2)"
    aria-label="Rent to Own"
  >
    <span>Rent to Own</span>
    <span class="caret icon-carrot fs-10"></span>
  </button>
  <a *ngIf="storefrontEnabled" routerLink="/shop/attachments" class="mobile-chip text-decoration-none">Attachments</a>
  <button
    type="button"
    class="mobile-chip"
    [class.mobile-chip--open]="openDropdown === 3"
    (click)="toggleDropdown($event, 3)"
    aria-label="Locations"
  >
    <span>Locations</span>
    <span class="caret icon-carrot fs-10"></span>
  </button>
</div>

<!-- Mobile: single dropdown sheet that renders the matching template -->
<div
  class="mobile-dropdown-sheet d-lg-none"
  *ngIf="showMobileDropdowns && !commerceNavigation && openDropdown !== -1"
  (click)="handleMobileSheetClick($event)"
>
  <ng-container *ngIf="openDropdown === 3; else mobileCategoriesSheet">
    <ng-container *ngTemplateOutlet="locationsDropdownContent"></ng-container>
  </ng-container>
  <ng-template #mobileCategoriesSheet>
    <ng-container *ngTemplateOutlet="currentSelectedDropdown"></ng-container>
  </ng-template>
</div>

<!-- Desktop: hover, click, and keyboard-accessible dropdowns with crawlable links -->
<div
  class="nav-dropdown d-none d-lg-inline-block mr-3"
  [class.nav-dropdown--open]="openDropdown === 0"
  (mouseenter)="hoverMenu(0)" (mouseleave)="hoverMenuEnd(0)"
  (focusin)="focusMenu(0)" (focusout)="blurMenu($event, 0)"
>
  <button type="button"
    class="nav-dropdown__toggle cursor-pointer text-white d-flex align-items-center"
    (click)="clickMenu($event, 0)"
    [attr.aria-expanded]="openDropdown === 0"
  >
    <span class="ml-2">Equipment Rentals</span>
    <span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div class="nav-dropdown__menu fs-15">
    <div class="arrow-up"></div>
    <ng-template [ngTemplateOutlet]="currentSelectedDropdown"></ng-template>
  </div>
</div>

<div
  class="nav-dropdown d-none d-lg-inline-block mr-3"
  [class.nav-dropdown--open]="openDropdown === 1"
  (mouseenter)="hoverMenu(1)" (mouseleave)="hoverMenuEnd(1)"
  (focusin)="focusMenu(1)" (focusout)="blurMenu($event, 1)"
>
  <button type="button"
    class="nav-dropdown__toggle cursor-pointer text-white d-flex align-items-center"
    (click)="clickMenu($event, 1)"
    [attr.aria-expanded]="openDropdown === 1"
  >
    <span class="ml-2">Buy it Now</span>
    <span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div class="nav-dropdown__menu fs-15">
    <div class="arrow-up"></div>
    <ng-template [ngTemplateOutlet]="currentSelectedDropdown"></ng-template>
  </div>
</div>

<div
  class="nav-dropdown d-none d-lg-inline-block mr-3"
  [class.nav-dropdown--open]="openDropdown === 2"
  (mouseenter)="hoverMenu(2)" (mouseleave)="hoverMenuEnd(2)"
  (focusin)="focusMenu(2)" (focusout)="blurMenu($event, 2)"
>
  <button type="button"
    class="nav-dropdown__toggle cursor-pointer text-white d-flex align-items-center"
    (click)="clickMenu($event, 2)"
    [attr.aria-expanded]="openDropdown === 2"
  >
    <span class="ml-2">Rent to Own</span>
    <span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div class="nav-dropdown__menu fs-15">
    <div class="arrow-up"></div>
    <ng-template [ngTemplateOutlet]="currentSelectedDropdown"></ng-template>
  </div>
</div>

<!-- Phone Number (Desktop). With the storefront on, it moves under the logo in the header. -->
<a
  *ngIf="!storefrontEnabled"
  href="tel:(866) 455-8531"
  class="text-white text-decoration-none d-none d-lg-inline-block header-phone-left"
>
  (866) 455-8531
</a>

<a *ngIf="storefrontEnabled && !commerceNavigation" routerLink="/shop/attachments"
  class="nav-link-item cursor-pointer text-white d-none d-lg-inline-flex align-items-center mr-3 text-decoration-none">
  <span class="ml-2">Attachments</span>
</a>
<div *ngIf="commerceNavigation" class="nav-dropdown d-none d-lg-inline-block mr-3" [class.nav-dropdown--open]="openDropdown === 4"
  (mouseenter)="hoverMenu(4)" (mouseleave)="hoverMenuEnd(4)"
  (focusin)="focusMenu(4)" (focusout)="blurMenu($event, 4)">
  <button type="button" class="nav-dropdown__toggle btn btn-link p-0 text-white d-flex align-items-center"
    (click)="clickMenu($event, 4)" [attr.aria-expanded]="openDropdown === 4" aria-controls="desktop-attachments-menu">
    <span class="ml-2">Attachments</span><span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div id="desktop-attachments-menu" class="nav-dropdown__menu nav-dropdown__menu--attachments nav-dropdown__menu--attachments-two-column fs-15">
    <div class="arrow-up"></div>
    <ng-container *ngTemplateOutlet="attachmentsDropdownContent"></ng-container>
  </div>
</div>

<div *ngIf="departmentNavigationEnabled" class="nav-dropdown d-none d-lg-inline-block mr-3" [class.nav-dropdown--open]="openDropdown === 6"
  (mouseenter)="hoverMenu(6)" (mouseleave)="hoverMenuEnd(6)"
  (focusin)="focusMenu(6)" (focusout)="blurMenu($event, 6)">
  <button type="button" class="nav-dropdown__toggle btn btn-link p-0 text-white d-flex align-items-center"
    (click)="clickMenu($event, 6)" [attr.aria-expanded]="openDropdown === 6" aria-controls="desktop-departments-menu">
    <span>Shop by Department</span><span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div id="desktop-departments-menu" class="nav-dropdown__menu nav-dropdown__menu--attachments fs-15">
    <div class="arrow-up"></div><ng-container *ngTemplateOutlet="departmentsDropdownContent"></ng-container>
  </div>
</div>

<!-- Locations Dropdown -->
<div
  class="nav-dropdown d-none d-lg-inline-block ml-3"
  [class.nav-dropdown--open]="openDropdown === 3"
  (mouseenter)="hoverMenu(3)" (mouseleave)="hoverMenuEnd(3)"
  (focusin)="focusMenu(3)" (focusout)="blurMenu($event, 3)"
>
  <button type="button"
    class="nav-dropdown__toggle cursor-pointer text-white d-flex align-items-center"
    (click)="clickMenu($event, 3)"
    [attr.aria-expanded]="openDropdown === 3"
  >
    <span class="ml-2">Locations</span>
    <span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div class="nav-dropdown__menu nav-dropdown__menu--wide fs-15">
    <div class="arrow-up"></div>
    <ng-template [ngTemplateOutlet]="locationsDropdownContent"></ng-template>
  </div>
</div>

<ng-container *ngIf="!commerceNavigation">
  <!-- Connect Link -->
  <a
    [routerLink]="['/', 'connect']"
    class="nav-link-item cursor-pointer text-white d-none d-lg-inline-flex align-items-center ml-3 text-decoration-none"
  >
    <span class="ml-2">Connect</span>
  </a>

  <!-- GPS Link -->
  <a
    [routerLink]="['/', 'gps']"
    class="nav-link-item cursor-pointer text-white d-none d-lg-inline-flex align-items-center ml-3 text-decoration-none"
  >
    <span class="ml-2">GPS</span>
  </a>
</ng-container>
<div *ngIf="commerceNavigation" class="nav-dropdown d-none d-lg-inline-block ml-3" [class.nav-dropdown--open]="openDropdown === 5"
  (mouseenter)="hoverMenu(5)" (mouseleave)="hoverMenuEnd(5)"
  (focusin)="focusMenu(5)" (focusout)="blurMenu($event, 5)">
  <button type="button" class="nav-dropdown__toggle btn btn-link p-0 text-white d-flex align-items-center"
    (click)="clickMenu($event, 5)" [attr.aria-expanded]="openDropdown === 5" aria-controls="desktop-services-menu">
    <span>Services</span><span class="caret icon-carrot text-white fs-10"></span>
  </button>
  <div id="desktop-services-menu" class="nav-dropdown__menu nav-dropdown__menu--compact fs-15">
    <div class="p-4"><a class="d-block mb-3" routerLink="/connect">Connect</a><a class="d-block mb-3" routerLink="/gps">GPS</a><a class="d-block" href="tel:(866) 455-8531">(866) 455-8531</a></div>
  </div>
</div>

<!-- SEO: sr-only navigation links mirroring the top-level header tabs.
     Kept as the pre-existing accessibility fallback for viewports where the visible nav is
     hidden. We intentionally do NOT include per-city Locations links here — those are
     already covered by sitemap_search_results_types_cities*.xml, and a long list of
     hidden links would risk a Google "hidden text" penalty. -->
<!-- tabindex="-1" keeps these visually hidden links out of the keyboard tab order
     (they were previously skipped via the wrapper's display: none `.collapse` class);
     crawlers still follow them. -->
<nav class="seo-nav" aria-label="Equipment categories">
  <a [routerLink]="['/', 'equipment-rentals', 'all']" tabindex="-1">Equipment Rentals</a>
  <a [routerLink]="['/', 'equipment-for-sale', 'all']" tabindex="-1">Buy it Now</a>
  <a *ngIf="storefrontEnabled" [routerLink]="['/shop', 'attachments']" tabindex="-1">Rubbl Attachment Products</a>
  <a *ngIf="departmentNavigationEnabled" [routerLink]="['/shop']" tabindex="-1">Shop by Department</a>
  <a [routerLink]="['/', 'equipment-rentals', 'all']" [queryParams]="{ rpoEnabled: true }" tabindex="-1">Rent to Own</a>
  <a [routerLink]="['/', 'connect']" tabindex="-1">Connect</a>
  <a [routerLink]="['/', 'gps']" tabindex="-1">GPS</a>
</nav>

<ng-template #locationsDropdownContent>
  <div class="p-4">
    <h4 class="mb-4">Locations</h4>
    <div class="locations-columns">
      <div class="locations-column" *ngFor="let loc of locationsData">
        <h6 class="locations-state">{{ loc.state }}</h6>
        <ul class="list-unstyled mb-3">
          <li *ngFor="let city of loc.cities" class="locations-city">
            <a
              class="font-weight-light text-dark"
              [routerLink]="['/', 'equipment-rentals', 'all', getLocationRoute(city, loc.stateAbbr)]"
            >{{ city }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #attachmentsDropdownContent>
  <div class="attachment-mega attachment-mega--two-column" aria-label="Browse attachment departments">
    <div class="attachment-mega__column">
      <h4><a routerLink="/shop/attachments">Shop All Attachments <span aria-hidden="true">&rarr;</span></a></h4>
      <a *ngIf="attachmentTypeListed('excavator')" class="d-block mb-2" routerLink="/shop/attachments/excavator-attachments">Excavator Attachments</a>
      <a *ngIf="partsNavigationEnabled" class="d-block mb-2" routerLink="/shop/attachments/parts-accessories">Parts &amp; Accessories</a>
      <a class="d-block mb-3" routerLink="/shop/attachments/shop-by-machine">Shop by Machine</a>
      <div *ngFor="let machine of attachmentMachineTypes" class="attachment-mega__row attachment-mega__collection-row"
        [class.attachment-mega__row--active]="selectedAttachmentMachine.handle === machine.handle"
        (mouseenter)="selectAttachmentMachine(machine)">
        <a class="attachment-mega__collection-link" [routerLink]="['/shop', 'attachments', machine.handle]"
          (focus)="selectAttachmentMachine(machine)">{{ machine.name }}</a>
        <button type="button" class="attachment-mega__expand" [attr.aria-label]="'Browse ' + machine.name + ' categories'"
          [attr.aria-expanded]="selectedAttachmentMachine.handle === machine.handle"
          (focus)="selectAttachmentMachine(machine)" (click)="selectAttachmentMachine(machine)"><span aria-hidden="true">&rsaquo;</span></button>
      </div>
    </div>
    <div class="attachment-mega__column">
      <h4><a [routerLink]="['/shop', 'attachments', selectedAttachmentMachine.handle]">Shop All {{ selectedAttachmentMachine.name }} <span aria-hidden="true">&rarr;</span></a></h4>
      <div *ngFor="let category of attachmentCategories" class="attachment-mega__row attachment-mega__collection-row"
        [class.attachment-mega__row--active]="selectedAttachmentCategory?.handle === category.handle"
        (mouseenter)="selectAttachmentCategory(category)">
        <a class="attachment-mega__collection-link" [routerLink]="['/shop', 'attachments', selectedAttachmentMachine.handle, category.handle]"
          (focus)="selectAttachmentCategory(category)">{{ category.name }}</a>
        <button type="button" class="attachment-mega__expand" [attr.aria-label]="'Browse ' + category.name + ' products'"
          [attr.aria-expanded]="selectedAttachmentCategory?.handle === category.handle"
          (focus)="selectAttachmentCategory(category)" (click)="selectAttachmentCategory(category)"><span aria-hidden="true">&rsaquo;</span></button>
      </div>
      <p *ngIf="attachmentCategoriesLoading" role="status">Loading categories…</p>
      <p *ngIf="attachmentCategoriesError" role="status">Categories could not load. Use the department link above to browse.</p>
      <p *ngIf="!attachmentCategoriesLoading && !attachmentCategoriesError && !attachmentCategories.length"><a [routerLink]="['/shop', 'attachments', selectedAttachmentMachine.handle]">Browse all {{ selectedAttachmentMachine.name }} attachments</a><br /><a routerLink="/shop/attachments/shop-by-machine" [queryParams]="{ machine: selectedAttachmentMachine.handle }">Find attachments for your exact machine</a></p>
    </div>
  </div>
</ng-template>

<ng-template #currentSelectedDropdown>
  <div class="p-4">
    <h4 class="mb-4">{{ title }}</h4>
    <div class="card-columns">
      <div
        class="card border-0"
        *ngFor="let category of popularMachineCategoryData"
      >
        <div class="d-flex justify-content-between">
          <a
            class="font-weight-light text-dark"
            [routerLink]="['/', category.route, category.header]"
            [queryParams]="machineCardParams(category.queryParams)"
            >{{ category.header }}</a
          >
          <span class="text-grey">({{ category.subHeader }})</span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <a
        class="btn-outline-success btn br-5 mr-2 mb-2"
        [routerLink]="['/', selectedRouteSegment(), 'all']"
        [queryParams]="queryParams"
        >View All Categories</a
      >
      <a *ngIf="departmentNavigationEnabled && selectedRoute === 'equipment-for-sale'" class="btn-outline-success btn br-5 ml-2 mb-2" routerLink="/shop">
        Shop by Department
      </a>
    </div>
  </div>
</ng-template>

<ng-template #departmentsDropdownContent>
  <div class="attachment-mega" aria-label="Shop by department">
    <div class="attachment-mega__column">
      <h4><a routerLink="/shop">All departments &rarr;</a></h4>
      <button *ngFor="let department of departments" type="button" class="attachment-mega__row"
        [class.attachment-mega__row--active]="selectedDepartment.handle === department.handle"
        (mouseenter)="selectedDepartment = department" (focus)="selectedDepartment = department" (click)="selectedDepartment = department">
        {{ department.name }} <span aria-hidden="true">&rsaquo;</span>
      </button>
    </div>
    <div class="attachment-mega__column">
      <h4><a [routerLink]="['/shop', selectedDepartment.handle]">{{ selectedDepartment.name }} &rarr;</a></h4>
      <a *ngFor="let category of selectedDepartmentCategories" class="attachment-mega__row" [routerLink]="['/shop', selectedDepartment.handle, category.handle]">{{ category.name }}</a>
      <p *ngIf="!selectedDepartmentCategories.length">Products are being prepared for this department.</p>
    </div>
    <div class="attachment-mega__column">
      <h4>Find products for the job</h4><p>{{ selectedDepartment.description }}</p>
      <a class="d-block mb-3" [routerLink]="['/shop', selectedDepartment.handle]">Browse {{ selectedDepartment.name }}</a>
      <a class="d-block" routerLink="/shop/products">Browse all products</a>
    </div>
  </div>
</ng-template>
